var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Layers-st0{fill:currentColor;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Layers-st0",
    d: "M22.6,4.7l-9.1-4.3c-1-0.5-2.1-0.5-3.1,0L1.4,4.7c-1.1,0.5-1.7,1.8-1.2,3c0.2,0.5,0.7,1,1.2,1.2l9.1,4.3 c1,0.5,2.1,0.5,3.1,0l9.1-4.3c1.1-0.5,1.7-1.8,1.2-3C23.6,5.3,23.2,4.9,22.6,4.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Layers-st0",
    d: "M21.5,11.5l0.4,0.2c0.2,0.1,0.3,0.3,0.3,0.5c0,0.1-0.1,0.2-0.3,0.3l-9.1,4.3c-0.2,0.1-0.5,0.2-0.7,0.2 c-0.3,0-0.5-0.1-0.7-0.2l-9.1-4.3c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.1,0.1-0.2,0.3-0.3l0.4-0.2l-2-1C0.2,10.9,0,11.4,0,12 c0,0.9,0.5,1.7,1.4,2.1l9.1,4.3c1,0.5,2.1,0.5,3.1,0l9.1-4.3c0.8-0.4,1.4-1.2,1.4-2.1c0-0.6-0.2-1.1-0.6-1.5L21.5,11.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Layers-st0",
    d: "M21.5,16.7l0.4,0.2c0.2,0.1,0.3,0.3,0.3,0.5c0,0.1-0.1,0.2-0.3,0.3L12.7,22c-0.2,0.1-0.5,0.2-0.7,0.2 c-0.3,0-0.5-0.1-0.7-0.2l-9.1-4.3c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.1,0.1-0.2,0.3-0.3l0.4-0.2l-2-1C0.2,16.2,0,16.7,0,17.3 c0,0.9,0.5,1.7,1.4,2.1l9.1,4.3c1,0.5,2.1,0.5,3.1,0l9.1-4.3c0.8-0.4,1.4-1.2,1.4-2.1c0-0.6-0.2-1.1-0.6-1.5L21.5,16.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/Layers.d3a45faced0f6e1c14fd764d06569377.svg";
export { ForwardRef as ReactComponent };